import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const AccountOpeningSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Open your first account' onButtonClick={() => navigate('/library/manage-contacts')} />
}
